import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import LoaderButton from '../components/loaderButton'
import Slider from '../chassis/slider'

import { ReduxFormProps } from '../forms'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  cancel: Callback
  onTermChange: Callback
  currentLoanTerm: number
}

export interface FormProps {
  newLoanTerm: string
}

// eslint-disable-next-line
export class EditLoanTermForm extends Component<
  ReduxFormProps<Props, FormProps>
> {
  static displayName = 'EditLoanTermForm'

  render() {
    const { handleSubmit, submitting, cancel, currentLoanTerm, onTermChange } =
      this.props

    return (
      <form
        onSubmit={handleSubmit}
        className="form"
        data-test="edit-loan-term-form"
      >
        <div className="user-profile-edit">
          <div className="user-profile-edit__form">
            <h2 className="user-profile-edit__form__header--state">
              Select the new Loan Term
            </h2>
            <hr className="form__hr user-profile-edit__form__hr4" />
            <div className="user-profile-edit__form__state">
              <Slider
                name="newLoanTerm"
                min={30}
                max={72}
                step={6}
                onAfterStepChange={onTermChange}
                initialValue={currentLoanTerm}
                formatTooltip={(currentValue) => `${currentValue}`}
                formatTooltipSubtext={() => 'New Loan Term'}
              />
            </div>
            <hr className="form__hr user-profile-edit__form__hr5" />
            <div className="form__group user-profile-edit__form__button">
              <LoaderButton
                className="button button--primary user-profile-edit__form__button--submit"
                isLoading={submitting}
                disabled={submitting}
                data-test="edit-loan-term-form-submit-button"
              >
                Update Loan Term
              </LoaderButton>
              <a
                onClick={cancel}
                className="button button--secondary user-profile-edit__form__button--cancel"
                data-test="edit-loan-term-form-cancel-button"
                aria-label="cancel"
              >
                Cancel
              </a>
            </div>
          </div>
        </div>
      </form>
    )
  }
}

const EditLoanTermWithForm = reduxForm<FormProps, Props>({
  form: 'EditLoanTermForm',
})(EditLoanTermForm)

const selector = formValueSelector('EditLoanTermForm')
const EditLoanTermFormConnected = connect((state) => {
  const selectedLoanTerm = selector(state, 'newLoanTerm')
  return { selectedLoanTerm }
})(EditLoanTermWithForm)

export default EditLoanTermFormConnected
